<template>
  <div class="loading-wrap" :class="{ 'loading-text': type === 'text' }">
    <div v-if="type === 'spinner'" class="spinner"></div>
    <span v-else class="loading-text">{{ text }}</span>
  </div>
</template>

<script setup lang="ts">
interface Props {
  type?: "spinner" | "text";
  text?: string;
}

withDefaults(defineProps<Props>(), {
  type: "spinner",
  text: "加载中...",
});
</script>

<style scoped lang="scss">
.loading-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;

  &.loading-text {
    height: auto;
    padding: 40px 20px;
  }

  .spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f7f7f7;
    border-top: 4px solid #ffb400;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  .loading-text {
    color: #888;
    font-size: 16px;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
